'use strict';


export default function($http) {
	'ngInject';

	return {
		require: '^ngModel',
		link: link,
		scope: {
			url: '@',
			cache: '<',
		},
	};

	function link(scope, element, attrs, ngModelCtrl) {
		let fetching = false;

		function _fetch() {
			if (fetching) return;
			fetching = true;
			$http.get(scope.url, {cache: !!scope.cache}).then((response) => {
				ngModelCtrl.$setViewValue(response.data);
			}, (error) => {
				$log.error(error);
			}).finally(() => {
				fetching = false;
			});
		}

		_fetch();
	}
}
